import script from "./VideoRecorder.vue?vue&type=script&setup=true&lang=js"
export * from "./VideoRecorder.vue?vue&type=script&setup=true&lang=js"

import "./VideoRecorder.vue?vue&type=style&index=0&id=fc55abc6&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fc55abc6"]])

export default __exports__